import {RelationshipType} from '../../backend/enums/relationship-type';
import {translations} from '../../i18n/translations';

/**
 * Array with the available relationship types in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(relationshipTypes[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const relationshipTypes: Array<{
  translation: string;
  type: RelationshipType;
}> = [
  {
    translation: translations.relationship_types[RelationshipType.Family],
    type: RelationshipType.Family,
  },
  {
    translation: translations.relationship_types[RelationshipType.Friend],
    type: RelationshipType.Friend,
  },
  {
    translation: translations.relationship_types[RelationshipType.Healthcare],
    type: RelationshipType.Healthcare,
  },
  {
    translation: translations.relationship_types[RelationshipType.Service],
    type: RelationshipType.Service,
  },
  {
    translation: translations.relationship_types[RelationshipType.Other],
    type: RelationshipType.Other,
  },
];
